var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTenderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 68.0045C53.0015 68.0045 68 53.005 68 34.5022C68 15.9995 53.0015 1 34.5 1C15.9985 1 1 15.9995 1 34.5022C1 53.005 15.9985 68.0045 34.5 68.0045Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2288 9.73438C30.2288 9.73438 31.485 15.5255 26.3763 18.8637C26.3763 18.8637 22.0811 21.6516 17.5586 17.9783C17.5586 17.9783 26.2566 19.5697 30.2288 9.73438Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7713 9.73438C38.7713 9.73438 37.515 15.5255 42.6238 18.8637C42.6238 18.8637 46.919 21.6516 51.4415 17.9783C51.4415 17.9783 42.7434 19.5697 38.7713 9.73438Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7529 44.5645C44.7529 48.2856 40.1586 51.3008 34.4995 51.3008C28.8404 51.3008 24.2461 48.2856 24.2461 44.5645",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7529 44.5645C44.7529 48.2856 40.1586 51.3008 34.4995 51.3008C28.8404 51.3008 24.2461 48.2856 24.2461 44.5645",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3848 28.543C30.3848 28.543 24.6659 36.7271 14.9629 29.3566L30.3848 28.543Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3848 28.543C30.3848 28.543 24.6659 36.7271 14.9629 29.3566",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6875 28.543C38.6875 28.543 44.4064 36.7271 54.1095 29.3566L38.6875 28.543Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6875 28.543C38.6875 28.543 44.4064 36.7271 54.1095 29.3566",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5978 47.306C60.7012 47.306 64.0276 43.9793 64.0276 39.8756C64.0276 35.772 60.7012 32.4453 56.5978 32.4453C52.4944 32.4453 49.168 35.772 49.168 39.8756C49.168 43.9793 52.4944 47.306 56.5978 47.306Z",
    fill: "#F97D85"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0021 47.306C15.1055 47.306 18.4319 43.9793 18.4319 39.8756C18.4319 35.772 15.1055 32.4453 11.0021 32.4453C6.89874 32.4453 3.57227 35.772 3.57227 39.8756C3.57227 43.9793 6.89874 47.306 11.0021 47.306Z",
    fill: "#F97D85"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenderIcon);
export default __webpack_public_path__ + "static/media/tender-icon.cf7cbd61f207def2c8295695d8ff09c3.svg";
export { ForwardRef as ReactComponent };